import { createFileRoute } from '@tanstack/react-router'
import PaymentInformationHistoryList from 'Royalty/components/Reports/PaymentInformation/PaymentInformationHistoryList'

export const Route = createFileRoute('/royalty/paymentinformation/history')({
    component: PaymentInformationHistoryList,
})
